import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ef3249c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "filter-sec" }
const _hoisted_3 = { class: "filters-container" }
const _hoisted_4 = { class: "rowe rowe-2" }
const _hoisted_5 = { class: "filter-btns-container" }
const _hoisted_6 = { class: "aparts-sec" }
const _hoisted_7 = { class: "aparts-container" }
const _hoisted_8 = { class: "aparts-grid grid" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"grid-head\" data-v-7ef3249c><h3 class=\"heading\" data-v-7ef3249c>Apartment</h3><h3 class=\"heading\" data-v-7ef3249c>Apartment Type</h3><h3 class=\"heading hide-mobile\" data-v-7ef3249c>Air COnditioner</h3><h3 class=\"heading hide-mobile\" data-v-7ef3249c>Beds</h3><h3 class=\"heading\" data-v-7ef3249c>Rent</h3><h3 class=\"heading\" data-v-7ef3249c>Status</h3></div>", 1)
const _hoisted_10 = {
  key: 0,
  class: "spinner-border",
  role: "status"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "info" }
const _hoisted_14 = { class: "info" }
const _hoisted_15 = {
  key: 0,
  class: "info hide-mobile"
}
const _hoisted_16 = {
  key: 1,
  class: "info hide-mobile"
}
const _hoisted_17 = { class: "info hide-mobile" }
const _hoisted_18 = { class: "info" }
const _hoisted_19 = {
  key: 2,
  class: "info free"
}
const _hoisted_20 = {
  key: 3,
  class: "info occupied"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "icon-btn" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-ellipsis" })
], -1))
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-circle-info" }, null, -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Edit ")
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = ["disabled", "onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-trash-can" }, null, -1))
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Delete ")
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddApartmentModal = _resolveComponent("AddApartmentModal")!
  const _component_Overlay = _resolveComponent("Overlay")!
  const _component_ApartmentDetailsModal = _resolveComponent("ApartmentDetailsModal")!
  const _component_BasicSpinner = _resolveComponent("BasicSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: _normalizeClass(["filter-btn", {active:_ctx.filter=='all'}]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filter = 'all'))
            }, "All Apartments", 2),
            _createElementVNode("button", {
              class: _normalizeClass(["filter-btn", {active:_ctx.filter=='available'}]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter = 'available'))
            }, "Available (Today)", 2),
            _createElementVNode("button", {
              class: _normalizeClass(["filter-btn", {active:_ctx.filter=='occupied'}]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter = 'occupied'))
            }, "Occupied (Today)", 2)
          ]),
          _createElementVNode("button", {
            class: "booking-btn app-btn",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addAppartForm = !_ctx.addAppartForm))
          }, "+ New Apartment")
        ])
      ])
    ]),
    (_ctx.addAppartForm)
      ? (_openBlock(), _createBlock(_component_Overlay, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_AddApartmentModal, {
              onCloseForm: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addAppartForm = false)),
              onApartmentCreated: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getApartments()))
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.apartmentDetails)
      ? (_openBlock(), _createBlock(_component_ApartmentDetailsModal, {
          key: 1,
          apartment: _ctx.currentApart,
          onApartmentUpdated: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getApartments())),
          onCloseForm: _cache[7] || (_cache[7] = ($event: any) => (_ctx.apartmentDetails = false))
        }, null, 8, ["apartment"]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          (_ctx.spin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterApartments, (apartment) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "data-grid",
              key: apartment._id
            }, [
              _createElementVNode("h6", _hoisted_13, _toDisplayString(apartment.name), 1),
              _createElementVNode("h6", _hoisted_14, _toDisplayString(apartment.type), 1),
              (apartment.ac)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_15, "AC"))
                : _createCommentVNode("", true),
              (!apartment.ac)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_16, "none"))
                : _createCommentVNode("", true),
              _createElementVNode("h6", _hoisted_17, _toDisplayString(apartment.beds), 1),
              _createElementVNode("h6", _hoisted_18, _toDisplayString(apartment.price) + " F", 1),
              (apartment.isFree)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_19, "free"))
                : _createCommentVNode("", true),
              (!apartment.isFree)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_20, "occupied"))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "action",
                onClick: ($event: any) => (_ctx.dropdown(apartment))
              }, [
                _hoisted_22,
                (_ctx.showDropdown && _ctx.currentApart._id == apartment._id)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "dropdown-container flex-column-start",
                      onFocusout: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showDropdown = false)),
                      tabindex: "0"
                    }, [
                      _createElementVNode("button", {
                        class: "btn edit-btn",
                        onClick: ($event: any) => (_ctx.displayApartDetails(apartment))
                      }, _hoisted_26, 8, _hoisted_23),
                      _createElementVNode("button", {
                        class: "btn edit-btn",
                        disabled: _ctx.deleteSpin,
                        onClick: ($event: any) => (_ctx.deleteApartment(apartment))
                      }, _hoisted_30, 8, _hoisted_27),
                      (_ctx.deleteSpin)
                        ? (_openBlock(), _createBlock(_component_BasicSpinner, { key: 0 }))
                        : _createCommentVNode("", true)
                    ], 32))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_21)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}